import axios from 'axios'
import BaseMixin from '@/shared/mixins/base.mixin'

const sessionEndpoint = `${import.meta.env.VITE_URL_API}/core/Session`

const sessionMixin = {
  name: 'SessionMixin',
  mixins: [BaseMixin],
  methods: {
    async getSessionData()
    {
      const response  = await axios.get(sessionEndpoint, {
        headers: {
          'x-session-id': this.session.id
        }
      })

      if (response.status === 204) {
        return null
      }

      if (response.status !== 200) {
        throw new Error(response.data.message || 'Error')
      }

      return response.data
    },
    async getPayload()
    {
      const response  = await axios.get(sessionEndpoint + '/Payload', {
        headers: {
          'x-session-id': this.session.id
        }
      })

        if (response.status === 204) {
          return null
        }

        if (response.status !== 200) {
          throw new Error(response.data.message || 'Error')
        }

        return response.data
    },
    async getSignerUrlDownload(urls)
    {
      const response  = await axios.post(
        sessionEndpoint + '/CreateDownloadUrl',
        urls,
        {
          headers: {
            'x-session-id': this.session.id
          }
        }
      )

      if (response.status !== 200) {
        throw new Error(response.data.message || 'Error')
      }

      return response.data
    }
  }
}
export default sessionMixin
